import styled from 'styled-components'

const StyledPageContent = styled.div`
  padding: 10px 30px;
`

export default StyledPageContent
